/**
 * Created by Tiger on 07/03/2022.
 */
import React, {useCallback, useState} from 'react';

export const useTableSelection = () => {
  const [selectedMacs, setSelectedMacs] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState([]);
  const addCode = useCallback((code) => {
    if (!selectedCodes.includes(code)) {
      const newCodes = [...selectedCodes];
      newCodes.push(code);
      setSelectedCodes([...newCodes]);
    }
  }, [selectedCodes]);
  const clear = useCallback(() => {
    setSelectedCodes([]);
    setSelectedMacs([]);
  }, [selectedCodes, selectedMacs]);
  return {
    selectedMacs, setSelectedMacs, selectedCodes, addSelectedCode: addCode, clearSelected: clear, rowSelection: {
      onSelect: useCallback(async ({ mac, originalData }, selected) => {
        console.log('onSelect:', mac, originalData);
        const copySelectedRows = new Set([...selectedMacs]);
        if (selected) {
          copySelectedRows.add(mac);
        } else {
          copySelectedRows.delete(mac);
        }
        addCode(originalData.product.code);
        setSelectedMacs([...copySelectedRows]);
      }, [selectedMacs, selectedCodes]),
      onSelectAll: useCallback(async (selected, selectedRows) => {
        console.log('onSelectAll:', selected, selectedRows);

        if (selected) {
          const copySelectedMacs = new Set([...selectedMacs]);
          selectedRows.forEach(({ mac, originalData }) => {
            copySelectedMacs.add(mac);
            addCode(originalData.product.code);
          });
          setSelectedMacs([...copySelectedMacs]);
        } else {
          setSelectedCodes([]);
          setSelectedMacs([]);
        }
      }, [selectedMacs, selectedCodes]),
      selectedRowKeys: selectedMacs,
    },
  };
};